/**
 * Índice de Componentes Compartilhados
 * Centraliza as exportações de todos os componentes reutilizáveis
 */

// Importações dos componentes
import { InfinitePagination, createSimplePagination, setupQuickPagination } from './pagination.js';
import { FormValidator, createQuickValidator, validateCPF, validateCNPJ } from './validation.js';
import { ModalManager, createInfoModal, createSuccessModal, createWarningModal, createErrorModal, createConfirmModal, createLoadingModal, createFormModal, createNewModal, notify } from './modal.js';
import { renderBarChart } from './barChart.js';
import './data-format.js';

// Pagination components
export {
    InfinitePagination,
    createSimplePagination,
    setupQuickPagination,
    setupInfiniteScroll,
    setupSearchWithPagination
} from './pagination.js';

// Validation components
export {
    FormValidator,
    createValidator,
    setupQuickValidation,
    validationRules,
    defaultMessages
} from './validation.js';

// Modal components
export {
    ModalManager,
    createInfoModal,
    createSuccessModal,
    createWarningModal,
    createErrorModal,
    createConfirmModal,
    createLoadingModal,
    createFormModal,
    createModal,
    notify
} from './modal.js';

// Chart components
export {
    renderBarChart
} from './barChart.js';

/**
 * Configuração global para componentes
 */
export const ComponentsConfig = {
    // Configurações padrão que podem ser sobrescritas
    pagination: {
        scrollThreshold: 0.9,
        loadingDelay: 2000
    },
    validation: {
        validateOnBlur: true,
        showSuccessIndicator: true
    },
    modal: {
        backdrop: true,
        keyboard: true,
        fade: true
    }
};

/**
 * Função para configurar componentes globalmente
 */
export function configureComponents(config) {
    Object.assign(ComponentsConfig, config);
}

/**
 * Utilitários para inicialização rápida
 */
export const QuickSetup = {
    /**
     * Configura paginação e busca para uma página de listagem
     */
    setupListingPage(container, loadUrl, searchInput = null, searchUrl = null) {
        return setupSearchWithPagination(container, loadUrl, searchInput, searchUrl);
    },
    
    /**
     * Configura validação básica para um formulário
     */
    setupFormValidation(form, fields) {
        return setupQuickValidation(form, fields);
    },
    
    /**
     * Cria modal de confirmação padrão
     */
    confirmAction(title, message, onConfirm, onCancel = null) {
        return createConfirmModal(title, message, onConfirm, onCancel);
    },
    
    /**
     * Mostra notificação de sucesso
     */
    showSuccess(message, title = 'Sucesso') {
        return notify.success(message, title);
    },
    
    /**
     * Mostra notificação de erro
     */
    showError(message, title = 'Erro') {
        return notify.error(message, title);
    }
};

/**
 * Inicialização automática de componentes baseada em atributos data-*
 */
export function autoInitComponents() {
    // Auto-init pagination
    $('[data-pagination]').each(function() {
        const $this = $(this);
        const config = {
            container: $this.attr('data-container') || this,
            loadUrl: $this.attr('data-load-url'),
            searchInput: $this.attr('data-search-input'),
            searchUrl: $this.attr('data-search-url')
        };
        
        if (config.loadUrl) {
            setupSearchWithPagination(config.container, config.loadUrl, config.searchInput, config.searchUrl);
        }
    });
    
    // Auto-init validation
    $('[data-validation]').each(function() {
        const $form = $(this);
        const validator = new FormValidator(this);
        
        // Parse validation rules from data attributes
        $form.find('[data-rules]').each(function() {
            const $field = $(this);
            const rules = JSON.parse($field.attr('data-rules'));
            const selector = `#${this.id}` || `[name="${this.name}"]`;
            validator.addField(selector, rules);
        });
    });
    
    // Auto-init modals
    $('[data-modal]').on('click', function(e) {
        e.preventDefault();
        const $this = $(this);
        const title = $this.attr('data-modal-title') || 'Modal';
        const content = $this.attr('data-modal-content') || '';
        const type = $this.attr('data-modal-type');
        
        if (type === 'confirm') {
            const onConfirm = window[$this.attr('data-modal-confirm')] || function() {};
            createConfirmModal(title, content, onConfirm);
        } else {
            createModal(title, content);
        }
    });
}

// Auto-initialize when DOM is ready
$(document).ready(() => {
    autoInitComponents();
});
